import styled from "styled-components";

const Container = styled.a`
    border-radius: 50px;
    border: solid white 2px;
    color: white;
    text-decoration: none;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 10px;
    width: 550px;
    height: 50px;
    text-align: center;
    padding: 0 20px;
    transition: all 0.3s ease;
    cursor: pointer;

    &:hover,
    &:focus-visible {
        background-color: #333;
        transform: scale(1.05);
    }

    @media (max-width: 768px) {
        width: 80%;
        max-width: 300px;
        height: 45px;
    }
`;

function Botao({ texto, link, tipo }) {
    // download: baixa o arquivo com o nome original; redirect: abre em nova aba
    const props = tipo === "download"
        ? { download: link.split("/").pop() }
        : { target: "_blank", rel: "noopener noreferrer" };

    return (
        <Container href={link} {...props}>
            <p>{texto}</p>
        </Container>
    );
}

export default Botao;
